export class CdRequestTypes {

  static GetProjectAndLivingComplexWithNoAvailable = '3B10DEFC-5B29-4800-9587-669BFF0FA698';
  static GetRegionCityAndProjectByObject = '4C90AAE7-AA20-4A4C-80B0-FB9412107BE6';
  static GetProjectAndLivingComplex = '0D0FF394-1172-40F2-AB8E-B7B5BE5C05A2';
  static GetTechnicalDocumentationApprovers = '684A4AAE-B5DD-41D1-AE45-C2B6743B954A';
  static GetIsAdministrator = 'C7399F82-1D49-4A3B-808F-11118AF29B75';
  static GetAuthorDepartment = '46314599-4B6D-4AB7-A5EF-1FF6F2841544';
  static ArDocumentIDPVirtualInfo = '664940FD-44F8-4FD6-BE91-1883359C6351';
  static ArDocumentKind = 'EB01185C-1EEA-47CE-A3F9-1E7B5BE8193E';
  static GetRdDivisionRoleProperties = 'C43FA1B2-C667-42B9-892E-EE654B10F760';
  static SignInfo = '2465212B-8A28-4A19-8D5A-62EABA0BD915';
  static AddDocumentToFavorites = '9E6AF495-641E-4381-BA86-0C15F22F3240';
  static RemoveDocumentFromFavorites = 'F83555BA-24FF-44E3-8DD6-DAC2082D3E2C';
  static GetLegalEntity = '85B84802-03DD-47E7-9A02-66061C674AFE';
  static GetUsersForTable = '2E5C7CA5-ACF1-4C88-B72C-3FFB4C8F1FFC';
  static GetRdInfo = '493AC87F-0FE2-4516-AAFB-099DFE38ED99';
  static HiddenWorksInfo = '41F89208-2E28-4DED-92C9-F40F1BEA4EFE';
  static CdCheckSignFile = '6FEB0D17-6B6E-4E2A-B63C-E69E9EB0202E';
  static CdCheckQrCodeFile = 'E4783065-FAA7-45F4-9803-A8B48752B78F';
  static GetEsApproversByObjects = 'F14D12C9-77D0-41A1-94EF-EBAE3DF3DB39';
  static CdGetSroInfoByKCKID = '6F2BB8D4-9856-45DD-B079-DC4E507D5993';
  static CdGetSystemInfo = 'B991D16A-C07A-486E-B7B5-798B1813DAFE';
  static CdGetSpecialistnumber = 'DAA41CFC-8DF4-48AF-9E52-84EFC88802A2';
  static CdGetGeodesicApproversByObjects = '55A746B0-17CB-42A4-BA38-C5AFD9A4C22F';
  static GetApprovementRoles = '79DB8F4A-672D-429A-9853-2EE272C7A8DE';
  static GetApprovementParticipants = '48288EEF-A76D-436B-827C-E45EB0F4F16C';
  static GetRenovationAndProjectType = '68E9CF1C-22D8-4891-B082-6C8920B5E9C7';
  static CheckUserInRole = '27458E64-F356-4BB7-9F99-7C96A05F24FB';
  static CdContractGetArticleID = '0E0623D6-9CB4-4E1E-953D-8292FD07A583';
  static CdSetSelectedTechDocPage = 'BE90D0DB-36CF-4664-B086-3FE9C4292771';
  static GetParentRoleID = '30FBD51D-8D88-4DD4-BF7D-C298D2790EC8';
  static CheckCertificate = '30079175-6C7F-404F-8E2F-F80C5BE4CF41';
  static PkSignFilesByDss = 'E61D3BE9-6331-436C-A876-A263998A0C34';
  static GetUserCertInfo = '0912E7AD-EC67-4760-8953-3C931BD88BBB';
  static CheckSigns = '114F82B2-B408-41D5-851F-2F339D829529';
  static InsertSignDssMessageInfo = 'EA59E9C6-9D22-4BDF-88AE-C3EEE8E5517B';
  static GetLastSignDssMessageInfo = '8DADEA50-7242-44D9-B355-6D7BCA6C82AF';
  static GetSignatureHash = '8F742397-895C-4344-BCA8-FEA328860AB1';
  static CheckPartnerInPerimeter =  'A972C7D6-C7DA-45B9-B3DF-E70D9154A35D';
  static UnlockCards =  '335932A9-306F-4160-8160-0EB48083BFC6';
  static RegisterCards =  'EEACAA5B-1D5E-473D-A856-0C03C43273FE';
  static GetInfoByPdc = '454D73D3-1DD6-4D93-89F6-C4083CB73842';
  static GetMyTasksCount = 'FEB8DD44-169C-4B22-BCB2-1540BDDEE632';
  static CdCheckFileSignaturesBySignerRoles = '027D20D1-AE61-4479-9DAD-D278CF7613EE';
  static GetPartnerSynonymAliasByExternalID = '3063479F-8C8C-491F-B44B-F208548AA562';
  static CheckSettingsLegalEntitiesRequest = '6E5ABB36-1D77-439B-9E62-BC7186857DFA';
  static IsObjectLockedRequestTypeID = '09AD8FAD-5E3D-4988-93B8-3D266A75F036';
}